<template>
  <div style="padding: 0px" class="sub-view">
    <div class="box-table">
      <table>
        <!-- judul tabel  -->
        <tr>
          <th>Tanggal Upload</th>
          <th>Periode</th>
          <th>Nama Dokumen</th>
          <th style="width: 20%">Tipe</th>
          <th>Aksi</th>
        </tr>
        <!-- start iterasi tabel -->
        <tr
          :key="penggajian.timestamp._seconds"
          v-for="penggajian in riwayatPenggajian"
        >
          <!-- tanggal upload -->
          <td>{{ toDate(penggajian.tanggalPengajuan._seconds) }}</td>
          <!-- periode penggajian -->
          <td>{{ toMonth(penggajian.timestamp._seconds) }}</td>
          <!-- nama file -->
          <td>
            <p
              @click="openDokumen(penggajian.lampiranUrl[0])"
              class="clickable"
            >
              <svg
                style="margin-right: 6px"
                width="16"
                height="16"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.3433 13.0001V17.0001C19.3433 17.5305 19.1325 18.0392 18.7575 18.4143C18.3824 18.7894 17.8737 19.0001 17.3433 19.0001H3.34326C2.81283 19.0001 2.30412 18.7894 1.92905 18.4143C1.55398 18.0392 1.34326 17.5305 1.34326 17.0001V13.0001M5.34326 8L10.3433 13M10.3433 13L15.3433 8M10.3433 13V1"
                  stroke="#4E4B66"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              {{ penggajian.judul }}
            </p>
            <p>
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.5714 11.1412V9.99833C10.5714 9.39212 10.3306 8.81074 9.90197 8.310248C9.47332 7.95343 8.89194 7.71261 8.28573 7.71261H3.7143C3.10809 7.71261 2.52671 7.95343 2.09806 8.310248C1.6694 8.81074 1.42859 9.39212 1.42859 9.99833V11.1412M8.28573 3.14118C8.28573 4.40355 7.26238 5.4269 6.00002 5.4269C4.73765 5.4269 3.7143 4.40355 3.7143 3.14118C3.7143 1.87882 4.73765 0.855469 6.00002 0.855469C7.26238 0.855469 8.28573 1.87882 8.28573 3.14118Z"
                  stroke="#4E4B66"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              {{ penggajian.namaKaryawan }}
            </p>
          </td>
          <!-- tipe/status -->
          <td>
            <div
              v-if="penggajian.tipe === `revisi`"
              class="status-rounded-pending"
            >
              Revisi
            </div>
            <div v-else class="status-rounded-accepted">Normal</div>
          </td>
          <!-- aksi -->
          <td class="aksi">
            <!-- acc -->
            <svg
              @click="kirimReview(penggajian.documentId, 'accepted')"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.7143 5.71387L7.85719 13.571L4.28577 9.99958"
                stroke="#27AE60"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <!-- tolak -->
            <svg
              @click="kirimReview(penggajian.documentId, 'rejected')"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.2857 5.71387L5.71423 14.2853M5.71423 5.71387L14.2857 14.2853"
                stroke="#EB5757"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </td>
        </tr>
        <!-- end iterasi tabel -->
      </table>
      <p v-if="isProsesData" class="empty-state-table">Memproses data..</p>
      <p
        v-else-if="!riwayatPenggajian || riwayatPenggajian.length === 0"
        class="empty-state-table"
      >
        Belum ada data
      </p>
    </div>

    <!-- modal berhasil -->
    <ModalBerhasil v-if="modalBerhasilIsOpen">
      <!-- icon modal -->
      <template v-slot:icon>
        <svg
          width="89"
          height="88"
          viewBox="0 0 89 88"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="44.5" cy="44" r="44" fill="#00BA88" />
          <path
            d="M65.4526 42.0845V44.0121C65.45 48.5303 63.987 52.9267 61.2817 56.5454C58.5764 60.1642 54.7738 62.8116 50.441 64.0927C46.1082 65.3737 41.4773 65.2199 37.2391 63.6541C33.0009 62.0883 29.3824 59.1944 26.9232 55.4041C24.464 51.6137 23.296 47.13 23.5933 42.6215C23.8906 38.1131 25.6372 33.8215 28.5728 30.3869C31.5084 26.9523 35.4756 24.5586 39.8827 23.5629C44.2899 22.5672 48.9008 23.0227 53.0279 24.8616M65.4526 27.2502L44.5002 48.2236L38.2145 41.9378"
            stroke="#FCFCFC"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </template>
      <!-- text modal -->
      <template v-slot:text>
        <h2>Sukses Tambah Data</h2>
      </template>
      <!-- close button -->
      <template v-slot:close>
        <svg
          @click="openCloseModalBerhasil(false)"
          class="close-button"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22.8574 9.14307L9.14307 22.8574M9.14307 9.14307L22.8574 22.8574"
            stroke="#1D1D1D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </template>
    </ModalBerhasil>
    <!-- end of modal berhasil -->
  </div>
</template>

<script>
import ModalBerhasil from "@/components/modal/ModalAlert";
import * as soluhaApi from "@/soluhaApi";
import * as soluhafire from "@/soluhafire";

export default {
  data() {
    return {
      riwayatPenggajian: [],
      modalBerhasilIsOpen: false,
      // apakah tabel sedang memproses data?
      isProsesData: false,
    };
  },

  components: {
    ModalBerhasil,
  },

  methods: {
    async getRiwayat() {
      this.isProsesData = true;
      let riwayat = await soluhaApi.riwayatPenggajian();
      riwayat = riwayat.filter((item) => item.status === "pending");
      this.riwayatPenggajian = riwayat;
      console.log(riwayat);
      this.isProsesData = false;
    },

    // buka atau tutup modal berhasil
    openCloseModalBerhasil(isOpen) {
      if (isOpen) {
        this.modalBerhasilIsOpen = true;
      } else {
        this.modalBerhasilIsOpen = false;
      }
    },

    async kirimReview(documentId, review) {
      await soluhaApi.reviewPenggajian(documentId, review);
      // hapus index yang ada di tabel
      this.riwayatPenggajian.splice(
        this.riwayatPenggajian.findIndex(
          (item) => item.documentId === documentId
        ),
        1
      );
      this.openCloseModalBerhasil(true);
    },

    toMonth(time) {
      let date = new Date(time * 1000);
      let month = date.getMonth();
      return soluhafire.NAMA_BULAN[month];
    },

    toDate(time) {
      return soluhaApi.epochToDate(time);
    },

    openDokumen(url) {
      window.open(url, "_blank");
    },
  },

  mounted() {
    this.getRiwayat();
  },
};
</script>
